module.exports = __webpack_public_path__ + "img/6953d52.jpg";